<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          hide-create
          :config="config"
          @view='view'
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      config,
    }
  },
  computed: {
    ...mapState('app', ['protocol']),
  },
  methods: {
    view (item) {
      const map = {
        REQUEST: 'siterequest',
        TRANSFER: 'siterequest',
        RETURNED: 'returned',
        DESTROY: 'disposed',
        FULLYUSED: 'fullyused',
        PATCH: 'patch'
      }

      this.$router.push(`${map[item.type]}/${item.id}`)

    }
  }
}
</script>
